import React from 'react'
import styled from 'styled-components'
import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import Navigation from './Navigation'
import TeamQuery from '../TeamPage/Query'
import TeamMembers from '../TeamPage/TeamMembers'

const Container = styled.div`
  margin: 6rem 0;
`

export default () => {
  const getEducators = (teamMembers, educators) =>
    teamMembers.filter((member) => educators.includes(member.slug))
  return (
    <Query
      render={(content, educators) => (
        <Layout>
          <Hero>
            <HeroTitle useH1>{content.title}</HeroTitle>
          </Hero>
          <Navigation />
          <TeamQuery
            render={({ content: teamContent, teamMembers }) => (
              <Container>
                <TeamMembers
                  teamLabels={teamContent.teams}
                  limitReached
                  noResults={teamContent.no_results}
                  teamMembers={getEducators(teamMembers, educators)}
                  includeDepartmentTitle={false}
                />
              </Container>
            )}
          />
        </Layout>
      )}
    />
  )
}
